// MOCK DATA - Nikomedya Turizm site içeriği (frontend-only)
// Not: Tüm veriler şimdilik statiktir. Backend eklendiğinde bu dosyadaki veriler API'den gelecektir.

export const company = {
  name: "Nikomedya Turizm",
  fullName: "Nikomedya Turizm Seyahat Otomotiv Gıda İnş. San. Tic. Ltd. Şti.",
  tagline: "turizm seyahat",
  phone: "+90 262 321 46 61",
  phoneHref: "tel:+902623214661",
  whatsapp: "+90 532 545 00 04",
  whatsappNumber: "905325450004",
  whatsappHref:
    "https://wa.me/905325450004?text=Merhaba%2C%20hizmetleriniz%20hakk%C4%B1nda%20teklif%20almak%20istiyorum.",
  email: "info@nikomedyaturizm.com",
  emailHref: "mailto:info@nikomedyaturizm.com",
  address: "İzmit / Kocaeli",
  mapsUrl:
    "https://www.google.com/maps/place/Nikomedya+Turizm+Seyahat/@40.7632106,29.948507,17z",
  mapsEmbed:
    "https://www.google.com/maps?q=40.7631922,29.9511624&hl=tr&z=16&output=embed",
  foundedYear: 1983,
  experienceYears: "42+",
};

export const navLinks = [
  { label: "Anasayfa", path: "/" },
  {
    label: "Kurumsal",
    path: "/kurumsal/hakkimizda",
    children: [
      { label: "Hakkımızda", path: "/kurumsal/hakkimizda" },
      { label: "Vizyon & Misyon", path: "/kurumsal/vizyon-misyon" },
      { label: "Kalite Politikamız", path: "/kurumsal/kalite-politikamiz" },
      { label: "Personel Politikamız", path: "/kurumsal/personel-politikamiz" },
      { label: "KVKK Bilgilendirmesi", path: "/kurumsal/kvkk-bilgilendirmesi" },
      { label: "Çerez Politikası", path: "/kurumsal/cerez-politikasi" },
    ],
  },
  { label: "Hizmetlerimiz", path: "/hizmetlerimiz" },
  { label: "Araç Filomuz", path: "/arac-filomuz" },
  { label: "Haberler", path: "/haberler" },
  { label: "İletişim", path: "/iletisim" },
];

export const heroSlides = [
  {
    id: 1,
    image: "/images/hero-1.webp",
    badge: "1983'ten Beri",
    title: "42 Yıldır Güvenle Taşıyoruz",
    description:
      "1983 yılından bu yana personel ve öğrenci taşımacılığında edindiğimiz deneyimle, her yolculuğu konforlu, güvenli ve zamanında gerçekleştirmeyi ilke edindik.",
    cta: { label: "Hizmetlerimiz", path: "/hizmetlerimiz" },
  },
  {
    id: 2,
    image: "/images/hero-2.webp",
    badge: "Kocaeli'nin Köklü Markası",
    title: "Tecrübe ve Güvenin Buluştuğu Nokta",
    description:
      "1983'ten beri sektörde edindiğimiz köklü deneyimle, personel ve öğrenci taşımacılığında en yüksek standartlarda hizmet veriyoruz. Yolculuklarınızda konfor ve güven her zaman ön planda.",
    cta: { label: "İletişim", path: "/iletisim" },
  },
];

export const stats = [
  { value: 42, suffix: "+", label: "Yıllık Tecrübe" },
  { value: 1983, suffix: "", label: "Kuruluş Yılı", noAnimate: false },
  { value: 4, suffix: "", label: "Uzman Hizmet Alanı" },
  { value: 24, suffix: "/7", label: "Kesintisiz Destek", prefix: "" },
];

export const services = [
  {
    id: "personel-tasimaciligi",
    title: "Personel Taşımacılığı",
    image: "/images/personel.webp",
    short:
      "Kurumunuzun personel ulaşımını modern araç filomuz ve deneyimli sürücü kadromuzla güvenle sağlıyoruz.",
    description:
      "1983 yılından bu yana personel taşımacılığında edindiğimiz tecrübeyle, kurumsal firmaların vardiya ve mesai saatlerine uygun, kesintisiz ulaşım çözümleri sunuyoruz. Ulusal çapta hizmet veren kurumsal firmalarla süregelen iş ortaklıklarımız, hizmet kalitemizin en büyük göstergesidir.",
    features: [
      "Vardiya saatlerine uygun esnek planlama",
      "Deneyimli ve profesyonel sürücü kadrosu",
      "Modern, bakımlı ve konforlu araç filosu",
      "Tam zamanında, kesintisiz hizmet anlayışı",
    ],
  },
  {
    id: "ogrenci-tasimaciligi",
    title: "Öğrenci Taşımacılığı",
    image: "/images/ogrenci.webp",
    short:
      "Çocuklarınızın okul yolculuğu bizimle güvende. Tüm yasal standartlara uygun araçlarla kesintisiz hizmet.",
    description:
      "Öğrenci taşımacılığında güvenlik bizim için her şeyden önce gelir. Yasal mevzuata tam uyumlu araçlarımız ve rehber personelimizle, velilerin içi rahat, öğrencilerin yolculuğu konforlu olsun diye çalışıyoruz.",
    features: [
      "Rehber personel eşliğinde güvenli yolculuk",
      "Yasal standartlara tam uyumlu araçlar",
      "Okul saatlerine göre planlanmış güzergahlar",
      "Düzenli araç bakımı ve denetimi",
    ],
  },
  {
    id: "vip-tasimaciligi",
    title: "VIP Taşımacılığı",
    image: "/images/vip.webp",
    short:
      "Özel davetler, toplantılar ve kurumsal organizasyonlar için lüks VIP araçlarla konforlu ulaşım deneyimi.",
    description:
      "VIP taşımacılık hizmetimizle özel misafirlerinizi, yöneticilerinizi ve iş ortaklarınızı en üst düzey konforla ağırlıyoruz. Lüks donanımlı araçlarımız ve protokol deneyimli sürücülerimizle fark yaratan bir ulaşım deneyimi sunuyoruz.",
    features: [
      "Lüks donanımlı VIP araç filosu",
      "Protokol deneyimli özel sürücüler",
      "Havalimanı karşılama ve transfer",
      "Kurumsal organizasyon çözümleri",
    ],
  },
  {
    id: "arac-kiralama",
    title: "Araç Kiralama",
    image: "/images/arac-kiralama.webp",
    short:
      "Kısa ve uzun dönem araç kiralama çözümleri. İhtiyacınıza uygun geniş araç yelpazesi.",
    description:
      "Bireysel ve kurumsal ihtiyaçlarınıza yönelik kısa ve uzun dönem araç kiralama hizmeti sunuyoruz. Geniş araç yelpazemiz ve esnek kiralama seçeneklerimizle bütçenize ve ihtiyacınıza en uygun çözümü birlikte belirliyoruz.",
    features: [
      "Kısa ve uzun dönem kiralama seçenekleri",
      "Geniş ve güncel araç yelpazesi",
      "Kurumsal filo kiralama çözümleri",
      "Şeffaf ve esnek sözleşme koşulları",
    ],
  },
];

export const credentials = [
  {
    icon: "BadgeCheck",
    title: "ISO 9001:2008",
    text: "Kalite Yönetim Sistemi",
  },
  {
    icon: "Leaf",
    title: "ISO 14001:2004",
    text: "Çevre Yönetim Sistemi",
  },
  {
    icon: "ShieldCheck",
    title: "OHSAS 18001:2007",
    text: "İş Sağlığı ve Güvenliği Yönetim Sistemi",
  },
  {
    icon: "Award",
    title: "Mesleki Yeterlilik",
    text: "Mesleki yeterlilik belgeli uzman kadro",
  },
];

export const certificates = [
  {
    id: "iso9001",
    name: "ISO 9001:2008",
    desc: "Kalite Yönetim Sistemi",
    image: "/images/sertifika-iso9001.webp",
  },
  {
    id: "iso14001",
    name: "ISO 14001:2004",
    desc: "Çevre Yönetim Sistemi",
    image: "/images/sertifika-iso14001.webp",
  },
  {
    id: "ohsas",
    name: "OHSAS 18001:2007",
    desc: "İş Sağlığı ve Güvenliği Yönetim Sistemi",
    image: "/images/sertifika-ohsas.webp",
  },
  {
    id: "myb1",
    name: "Mesleki Yeterlilik Belgesi",
    desc: "Ulaştırma sektörü mesleki yeterlilik",
    image: "/images/sertifika-myb1.webp",
  },
  {
    id: "myb2",
    name: "Mesleki Yeterlilik Belgesi",
    desc: "Ulaştırma sektörü mesleki yeterlilik",
    image: "/images/sertifika-myb2.webp",
  },
];

export const vizyonMisyon = {
  vizyon:
    "Teknolojiyi yakından takip eden firmamız, inovatif düşünce yapısıyla daima sektöre yön veren bir firma olmayı hedeflemektedir.",
  misyon:
    "Karşılıklı saygı ve dürüstlük ilkesinden ödün vermeden, sosyal sorumluluk bilinciyle topluma ve çevreye duyarlı bir firma olmanın yanı sıra müşteri memnuniyetini beklentilerin ötesine taşımak.",
  misyonVurgu: "İmkânsızı mümkün; kolay, zarif ve zevkli hale getirmek.",
};

export const kalitePolitikasi = {
  intro:
    "Globalleşen dünyada ve hızla gelişen ülkemizde müşteri beklentilerinin sürekli değiştiğini bilen firmamız; müşteri memnuniyetini üst düzeye taşımada etkin rol oynayan kalite standartlarını bünyesine dâhil ederek kendisini sürekli güncellemekte ve hizmet kalitesinden taviz vermemektedir.",
};

export const personelPolitikasi = {
  paragraphs: [
    "Hizmet üreten bir firma olarak müşteri memnuniyetinin; eğitimli, iyi motive edilmiş ve kendisini sürekli yenileyebilen personellerle mümkün olabileceğini biliyoruz.",
    "Alanında uzman kişi ve kurumlar tarafından, tüm çalışma arkadaşlarımızın gelişmesi amacıyla düzenli seminerler ve bilgilendirme toplantıları gerçekleştiriyoruz.",
    "Uzun süreli çalışma prensibiyle takım ruhunu oluşturmak, personel politikamızın temelini oluşturmaktadır.",
  ],
  principles: [
    "Eğitimli ve motive personel kadrosu",
    "Uzman eğitmenlerle düzenli seminerler",
    "Sürekli gelişim ve bilgilendirme toplantıları",
    "Uzun süreli çalışma ve takım ruhu prensibi",
  ],
};

export const whyUs = [
  {
    icon: "ShieldCheck",
    title: "Belgeli Güven",
    text: "OHSAS 18001:2007 ve kalite yönetim belgeleriyle desteklenen, denetlenebilir hizmet standardı.",
  },
  {
    icon: "Clock",
    title: "Tam Zamanında",
    text: "Her yolculukta dakiklik esastır. Planlanan saatte, planlanan yerde oluruz.",
  },
  {
    icon: "Users",
    title: "Deneyimli Kadro",
    text: "Alanında uzman, deneyimli sürücü ve operasyon ekibiyle profesyonel hizmet.",
  },
  {
    icon: "Bus",
    title: "Modern Filo",
    text: "Düzenli bakımları yapılan, konforlu ve güvenli araçlardan oluşan güncel filo.",
  },
  {
    icon: "MapPin",
    title: "Yerel Uzmanlık",
    text: "Kocaeli ve çevresini avucunun içi gibi bilen ekip; en verimli güzergah planlaması.",
  },
  {
    icon: "Headphones",
    title: "7/24 Destek",
    text: "Sorularınız ve talepleriniz için her an ulaşabileceğiniz iletişim kanalları.",
  },
];

export const timeline = [
  {
    year: "1983",
    title: "Yolculuk Başlıyor",
    text: "Kocaeli'nde personel taşımacılığı alanında farklı şirketler bünyesinde bireysel olarak çalışma hayatına başladık; sektörün eksiklerini analiz ederek tecrübe kazandık.",
  },
  {
    year: "1998",
    title: "Kurumsallaşma",
    text: "Edindiğimiz tecrübeyi Kocaeli Zafer Seyahat adıyla kurumsallaştırdık ve hizmet ağımızı genişlettik.",
  },
  {
    year: "2014",
    title: "Nikomedya Turizm",
    text: "17 Eylül 2014'te Nikomedya Turizm adıyla yepyeni bir yüzle, yarım asra yaklaşan tecrübemizi şehrimizin kadim adıyla kıymetli insanlarımızla buluşturduk.",
  },
  {
    year: "Bugün",
    title: "Ulusal Ölçekte Hizmet",
    text: "Memnun müşteri portföyümüze ilave olarak, ulusal çapta hizmet veren kurumsal firmalarla çalışma hayatımızı sürdürüyoruz.",
  },
];

export const news = [
  {
    id: "ohsas-180012007-is-sagligi-ve-guvenligi-yonetim-sistemi",
    title: "OHSAS 18001:2007 İş Sağlığı ve Güvenliği Yönetim Sistemi",
    date: "19.07.2025",
    views: 277,
    image: "/images/trans-1.webp",
    excerpt:
      "İş sağlığı ve güvenliği alanındaki hassasiyetimizi OHSAS 18001:2007 belgesiyle taçlandırdık.",
    content: [
      "Nikomedya Turizm olarak çalışanlarımızın ve yolcularımızın sağlığı ile güvenliği, hizmet anlayışımızın merkezinde yer almaktadır. Bu doğrultuda gerçekleştirilen kapsamlı denetimlerin ardından OHSAS 18001:2007 İş Sağlığı ve Güvenliği Yönetim Sistemi belgesini almaya hak kazandık.",
      "Bu belge; iş süreçlerimizde risklerin sistematik olarak tanımlandığını, değerlendirildiğini ve kontrol altında tutulduğunu uluslararası standartlarla tescillemektedir.",
      "Sektörümüzde güvenliği bir tercih değil, vazgeçilmez bir standart olarak görüyor; tüm operasyonlarımızı bu anlayışla sürdürüyoruz.",
    ],
  },
  {
    id: "nikomedya-turizm-kalitesini-belgelendirdi",
    title: "Nikomedya Turizm Kalitesini Belgelendirdi",
    date: "19.07.2025",
    views: 293,
    image: "/images/trans-2.webp",
    excerpt:
      "Çevreye olan duyarlılığımız ISO 14001:2004 Çevre Yönetim Sistemi belgesiyle tescillendi.",
    content: [
      "Kuruluşumuzdan bu yana benimsediğimiz çevreye ve topluma duyarlı hizmet anlayışımızı, uluslararası geçerliliğe sahip bir belgeyle daha taçlandırdık: Nikomedya Turizm, ISO 14001:2004 Çevre Yönetim Sistemi belgesini almaya hak kazandı.",
      "Yapılan bağımsız denetimler sonucunda; operasyonlarımızın çevresel etkilerinin sistematik olarak yönetildiği, doğaya ve topluma duyarlı iş süreçlerimizin uluslararası standartlara uygunluğu onaylandı.",
      "Nikomedya Turizm olarak kaliteyi ve çevre duyarlılığını bir hedef değil, günlük operasyonlarımızın doğal bir parçası olarak görüyoruz.",
    ],
  },
  {
    id: "marka-tescil-belgemiz",
    title: "Marka Tescil Belgemiz",
    date: "19.07.2025",
    views: 260,
    image: "/images/hero-2.webp",
    excerpt:
      "Nikomedya Turizm markası, Türk Patent ve Marka Kurumu nezdinde tescillenmiştir.",
    content: [
      "Şehrimizin kadim adını taşıyan Nikomedya Turizm markamız, Türk Patent ve Marka Kurumu nezdinde resmi olarak tescillenmiştir.",
      "Marka tescili; kurumsal kimliğimizin korunması, müşterilerimize sunduğumuz güvencenin hukuki zemine kavuşması ve markamızın uzun vadeli değerinin güvence altına alınması açısından önemli bir adımdır.",
      "42 yılı aşkın tecrübemizle inşa ettiğimiz güveni, tescilli markamızla geleceğe taşıyoruz.",
    ],
  },
];

export const aboutIntro = {
  title: "Taşımacılıkta Kalite ve Güvenin Sembolü",
  paragraphs: [
    "1983 yılında Kocaeli'nde personel taşımacılığı alanında farklı şirketler bünyesinde bireysel olarak başladığımız çalışma hayatında, sektörün eksiklerini analiz ederek kazandığımız tecrübeyi 1998 yılında Kocaeli Zafer Seyahat adıyla kurduğumuz firmamızla kurumsallaştırdık.",
    "Personel taşımacılığındaki tecrübemizi, o dönemde kentimizde yeni gelişmekte olan öğrenci taşımacılığı alanında da değerlendirerek hizmet alanımızı genişlettik ve büyüme hedeflerimizin önemli bir adımını daha gerçekleştirdik.",
    "Gelişen ve değişen çağın koşullarına ayak uydurmak ve daha kurumsal bir yapı kazanmak amacıyla, 17 Eylül 2014 tarihinde Nikomedya Turizm Seyahat Otomotiv Gıda İnş. San. Tic. Ltd. Şti. adıyla ülke çapında hizmet üreten bir firma haline geldik.",
    "Memnun müşteri portföyümüze ilave olarak, ulusal çapta hizmet veren kurumsal firmalarla çalışma hayatımızı sürdürmekteyiz.",
  ],
  certificatesNote:
    "ISO 9001:2008 Kalite Yönetim Sistemi, ISO 14001:2004 Çevre Yönetim Sistemi ve OHSAS 18001:2007 İş Sağlığı ve Güvenliği Yönetim Sistemi belgelerini bünyemize dâhil ederek, kaliteden ödün vermeden hizmet etmeye devam ediyoruz.",
};

export const filoCategories = [
  "Tümü",
  "Otobüs",
  "Midibüs & Minibüs",
  "VIP Araçlar",
  "Binek Araçlar",
];

export const filo = [
  {
    id: 1,
    name: "Turizm Otobüsü",
    category: "Otobüs",
    image: "/images/hero-1.webp",
    tags: ["46+1 Koltuk", "Klimalı"],
  },
  {
    id: 2,
    name: "Şehirlerarası Otobüs",
    category: "Otobüs",
    image: "/images/filo-otobus-1.webp",
    tags: ["Konfor Donanımı", "Geniş Bagaj"],
  },
  {
    id: 3,
    name: "Personel Servis Filomuz",
    category: "Midibüs & Minibüs",
    image: "/images/personel.webp",
    tags: ["Profesyonel Sürücü", "Düzenli Bakım"],
  },
  {
    id: 4,
    name: "Okul Servislerimiz",
    category: "Midibüs & Minibüs",
    image: "/images/ogrenci.webp",
    tags: ["Rehber Personel", "Yasal Donanım"],
  },
  {
    id: 6,
    name: "Servis Filomuz",
    category: "Midibüs & Minibüs",
    image: "/images/trans-1.webp",
    tags: ["Modern Filo", "Bakımlı Araçlar"],
  },
  {
    id: 7,
    name: "VIP Taşıma Aracı",
    category: "VIP Araçlar",
    image: "/images/vip.webp",
    tags: ["VIP Donanım", "Özel Sürücü"],
  },
  {
    id: 8,
    name: "VIP Vito",
    category: "VIP Araçlar",
    image: "/images/filo-vip-3.webp",
    tags: ["8+1 Koltuk", "Lüks İç Mekan"],
  },
  {
    id: 9,
    name: "VIP İç Mekan Konforu",
    category: "VIP Araçlar",
    image: "/images/filo-vip-2.webp",
    tags: ["Deri Koltuk", "Geniş İç Hacim"],
  },
  {
    id: 10,
    name: "Kiralık Binek Araçlar",
    category: "Binek Araçlar",
    image: "/images/arac-kiralama.webp",
    tags: ["Kısa & Uzun Dönem", "Geniş Araç Yelpazesi"],
  },
];

// İletişim formu gönderimlerini geçici olarak localStorage'a kaydediyoruz (MOCK)
export const saveContactSubmission = (data) => {
  const existing = JSON.parse(
    localStorage.getItem("nikomedya_contact_submissions") || "[]"
  );
  existing.push({ ...data, createdAt: new Date().toISOString() });
  localStorage.setItem(
    "nikomedya_contact_submissions",
    JSON.stringify(existing)
  );
  return true;
};
